var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8868 20.3794C21.8868 25.0071 18.1676 28.7586 13.5799 28.7586C8.99224 28.7586 5.27271 25.0063 5.27271 20.3794C5.27271 15.7526 8.99195 12 13.5799 12C18.1679 12 21.8868 15.7518 21.8868 20.3794Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9998 20.3794C30.9998 24.7354 29.1402 28.2681 26.8462 28.2681C24.5523 28.2681 22.6926 24.7354 22.6926 20.3794C22.6926 16.0235 24.552 12.4908 26.846 12.4908C29.1399 12.4908 30.9996 16.0223 30.9996 20.3794",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7273 20.3794C34.7273 24.2813 34.0734 27.4464 33.2665 27.4464C32.4596 27.4464 31.8059 24.2822 31.8059 20.3794C31.8059 16.4767 32.4598 13.3125 33.2665 13.3125C34.0731 13.3125 34.7273 16.4764 34.7273 20.3794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.cf9c5443c9315ab209dc0e4148fb1635.svg";
export { ForwardRef as ReactComponent };